import { createSignal } from '@verclam/pulsar';

export const DEFAULT_HOME_DOCUMENT_TYPE: number | null = null;

const homeDocumentTypeSignal = createSignal<number | null>(DEFAULT_HOME_DOCUMENT_TYPE);

export const setHomeDocumentType = (documentTypeId: number | null): void => {
	homeDocumentTypeSignal.value = documentTypeId;
};

export default homeDocumentTypeSignal;
